import React from "react";

import cx from "classnames";

import {MenuCategoryItem} from "@components/Menu/interfaces";

import styles from "./CategoryBannerImage.scss";

const BannerImageContainer = ({
  link,
  children,
}: {
  link: string;
  children: JSX.Element;
}): JSX.Element => {
  return link ? (
    <a data-testid="banner-link" href={link} target="_self">
      {children}
    </a>
  ) : (
    <>{children}</>
  );
};

const CategoryBannerImage = ({
  category,
}: {
  category: MenuCategoryItem;
}): JSX.Element => {
  let bannerImageIdentsClassName;

  if (category.banner_style === 0) {
    bannerImageIdentsClassName = "identation-banner-category-0";
  } else {
    bannerImageIdentsClassName = category.secondary_banner
      ? "identation-secondary-banner-category-1"
      : "identation-primary-banner-category-1";
  }

  return (
    <div
      className={cx(
        styles.categoryBannerImage,
        styles[bannerImageIdentsClassName]
      )}
    >
      <BannerImageContainer link={category.link ?? ""}>
        <>
          <img
            data-testid={`category-banner-img-${category.id}`}
            className={styles.showMedium}
            src={category.banner}
            alt=""
          />
          <img
            data-testid={`category-mobile-banner-${category.id}`}
            className={styles.showSmall}
            src={category.mobile_banner}
            alt=""
          />
        </>
      </BannerImageContainer>
    </div>
  );
};

export default CategoryBannerImage;
